// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"516":"team","594":"about"}[chunkId] + "." + {"516":"71420c2b","594":"a05f2d8b"}[chunkId] + ".js";
};